import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import splashLoaderGif from "../../assets/MW-Splash-Loader.gif";

/** One full playthrough of MW-Splash-Loader.gif (112 frames). */
export const SPLASH_ANIMATION_MS = 3360;

export default function SplashLoader() {
  // Bust cache so the GIF always restarts from frame 0 when shown.
  const src = useMemo(
    () => `${splashLoaderGif}?t=${Date.now()}`,
    [],
  );

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#000",
      }}
    >
      <Box
        component="img"
        src={src}
        alt="Loading"
        sx={{
          width: "min(90vw, 720px)",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
